import routerOptions0 from "/home/node/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/node/app/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}